import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { getPrefecturePath } from "../utils/seoRoutes";
import "./PrefectureSelector.css";

const REGIONS = [
  {
    id: "hokkaido",
    label: "北海道・東北",
    color: "#4a90e2",
    prefs: ["北海道", "青森県", "岩手県", "宮城県", "秋田県", "山形県", "福島県"],
  },
  {
    id: "kanto",
    label: "関東",
    color: "#f39c12",
    prefs: ["茨城県", "栃木県", "群馬県", "埼玉県", "千葉県", "東京都", "神奈川県"],
  },
  {
    id: "chubu",
    label: "中部",
    color: "#9333ea",
    prefs: ["新潟県", "富山県", "石川県", "福井県", "山梨県", "長野県", "岐阜県", "静岡県", "愛知県"],
  },
  {
    id: "kinki",
    label: "近畿",
    color: "#e91e63",
    prefs: ["三重県", "滋賀県", "京都府", "大阪府", "兵庫県", "奈良県", "和歌山県"],
  },
  {
    id: "chugoku",
    label: "中国",
    color: "#f59e0b",
    prefs: ["鳥取県", "島根県", "岡山県", "広島県", "山口県"],
  },
  {
    id: "shikoku",
    label: "四国",
    color: "#10b981",
    prefs: ["徳島県", "香川県", "愛媛県", "高知県"],
  },
  {
    id: "kyushu",
    label: "九州・沖縄",
    color: "#22c55e",
    prefs: ["福岡県", "佐賀県", "長崎県", "熊本県", "大分県", "宮崎県", "鹿児島県", "沖縄県"],
  },
];

function PrefectureSelector() {
  const navigate = useNavigate();
  const [hoveredPref, setHoveredPref] = useState(null);

  const handleClick = (pref) => {
    navigate(getPrefecturePath(pref));
  };

  return (
    <div className="prefecture-selector">
      {REGIONS.map((region) => (
        <div key={region.id} className="region-block">
          <div
            className="region-label"
            style={{
              backgroundColor: region.color + "22",
              color: region.color,
              borderLeft: `4px solid ${region.color}`,
            }}
          >
            {region.label}
          </div>
          <div className="pref-grid">
            {region.prefs.map((pref) => {
              const isHovered = hoveredPref === pref;
              return (
                <button
                  key={pref}
                  className="pref-btn"
                  style={{
                    borderColor: region.color,
                    color: isHovered ? "#ffffff" : region.color,
                    backgroundColor: isHovered ? region.color : "#ffffff",
                  }}
                  onMouseEnter={() => setHoveredPref(pref)}
                  onMouseLeave={() => setHoveredPref(null)}
                  onClick={() => handleClick(pref)}
                  aria-label={`${pref}の登山募集を見る`}
                >
                  {pref}
                </button>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}

export default PrefectureSelector;
